export default __webpack_public_path__ + "static/media/marathi_edu_f.3358a25b.wav";